import React, { Component } from 'react';
import { Button, Tooltip, ModalFooter } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

class MenuPartsFooter extends Component {

    renderOriginButton() {

        const { originStyle } = this.props.styles;

        return (
            <Button
                hidden={!this.props.onClickOrigin}
                id="origin"
                sm={12}
                color="link"
                style={{ ...originStyle, marginRight: 10 }}
                onClick={this.props.onClickOrigin}>
                {i18n.t('common:buttons.originBtn')}
            </Button>
        );
    }

    renderPublishedItemId = () => {

        if (!this.props.publishedItemId) return null;

        return (
            <div style={{ fontSize: 14, display: 'flex', flexDirection: 'column', marginRight: 'auto' }}>
                <div style={{ fontSize: 13 }}>{i18n.t('screens:categoryScreen.publishedId')}:</div>
                <div>{this.props.publishedItemId}</div>
            </div>
        );
    }

    renderSaveButton() {
        const { spaceBetween } = this.props.styles;

        return (
            <Button color="primary" sm={12} style={{}} >
                <MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
            </Button>
        )
    }

    renderPublishButton() {
        const { spaceBetween } = this.props.styles;
        const isDisabled = this.props.isPublishDisabled;

        return (
            <div id="publishMenuScreenButton" style={{ padding: '0 0 0 5px' }}>
                <div className="disabledButtonOverlay" hidden={!isDisabled}></div>
                <Button color="primary" sm={12} disabled={isDisabled} onClick={this.props.onClickPublish} >
                    <MaterialIcon icon="cloud_upload" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.publish')}</span>
                </Button>
                <Tooltip placement="top" disabled={!isDisabled}
                    isOpen={this.props.state.publishTooltipOpen} target="publishMenuScreenButton" toggle={this.props.publishTooltipToggle}>
                    {this.props.publishTooltipMsg}
                </Tooltip>
            </div>
        );
    }

    renderDeleteButton() {
        const isDisabled = this.props.isDeleteDisabled;

        return (
            <div id="deleteMenuBtn" style={{ padding: '0 0 0 5px' }}>
                <div className="disabledButtonOverlay" hidden={!isDisabled}></div>
                <Button color="primary" outline className="deleteMenuBtn" sm={12}
                    onClick={this.props.onClickDelete}
                    disabled={isDisabled}>
                    <span>
                        <MaterialIcon icon="delete" color="#0288D1" size={18} />
                    </span>
                    {i18n.t('common:buttons.delete')}
                </Button>
                <Tooltip disabled={!isDisabled} placement="top"
                    isOpen={this.props.state.tooltipOpen} target="deleteMenuBtn" toggle={this.props.deleteTooltipToggle}>
                    {this.props.deleteTooltipMsg}
                </Tooltip>
            </div>
        );
    }

    renderCopyButton() {

        const { spaceBetween } = this.props.styles;

        return (
            <Button color="primary" sm={12} style={{marginLeft: '5px'}} onClick={this.props.onClickCopy}>
                <MaterialIcon icon="file_copy" color="#fff" size={18} /><span>{i18n.t('common:buttons.copy')}</span>
            </Button>
        )
    }

    render() {

        const { footer, firstGroup, secondGroup } = styles;

        return (
            <ModalFooter style={footer}>
                <div style={firstGroup}>
                    {this.renderOriginButton()}
                    {this.renderPublishedItemId()}
                </div>
                <div style={secondGroup}>
                    {this.renderSaveButton()}
                    {this.renderPublishButton()}
                    {this.props.isCopyProductButton ? this.renderCopyButton() : null}
                    {this.props.onClickDelete ? this.renderDeleteButton() : null}
                </div>

            </ModalFooter>
        )
    }
}

export default MenuPartsFooter;

const styles = {
    footer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    firstGroup: {
        display: 'flex',
        flexDirection: 'row',
        width: 'calc(50% - 38px)'
    },
    secondGroup: {
        display: 'flex',
        flexDirection: 'row',
        width: 'calc(50% - 38px)',
        justifyContent: 'flex-end'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/MenuPartsFooter.js